export const BUDGET_MAIN_TABS = [
  { id: 'view', label: 'Master' },
  // { id: 'initial_quotation', label: 'Init Quot' },
  { id: 'prep', label: 'Quote preparation' },
  // { id: 'ordering', label: 'Ordering' }
];
